export default __webpack_public_path__ + "static/media/mobile-logo-big.3cc0bbb3.svg";